import React from "react";

import { Proposal } from "@fartherfinance/frontend/api/Investment/hooks/useGetProposal";

import { toSortable } from "@src/multiCustodian/components/Client/Accounts/Holdings/Components/BreakdownTable/HoldingsTable";
import Skeleton from "@src/sharedComponents/Skeleton/Skeleton";
import FullDataTable from "@src/sharedComponents/Table/FullDataTable";

interface Props {
  proposal: Proposal | undefined;
}

const columns = [
  "Lt Gains",
  "Lt Losses",
  "Lt Taxes",
  "St Gains",
  "St Losses",
  "St Taxes",
] as const;

const TradeConsequences: React.FC<Props> = (props) => {
  if (props.proposal === undefined) {
    return (
      <FullDataTable
        key={"consequences-loading"}
        useQueryParams={false}
        columns={columns}
        defaultSortColumn={["Lt Gains", "asc"]}
        rows={Array.from({ length: 1 }).map((_, idx) => ({
          key: idx.toString(),
          "Lt Gains": { value: <Skeleton width={100} />, fullValue: "" },
          "Lt Losses": { value: <Skeleton width={100} />, fullValue: "" },
          "Lt Taxes": { value: <Skeleton width={100} />, fullValue: "" },
          "St Gains": { value: <Skeleton width={100} />, fullValue: "" },
          "St Losses": { value: <Skeleton width={100} />, fullValue: "" },
          "St Taxes": { value: <Skeleton width={100} />, fullValue: "" },
        }))}
        emptyCell={<Skeleton />}
        hidePagination
        defaultRowsPerPage={3}
      />
    );
  }

  return (
    <FullDataTable
      key={"consequences-loaded"}
      useQueryParams={false}
      columns={columns}
      defaultSortColumn={["Lt Gains", "asc"]}
      rows={[
        {
          key: "0",
          "Lt Gains": {
            value:
              props.proposal.capitalConsequences.estimatedLongTermGainsDollars
                .toNumber()
                .toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                }),
            fullValue: toSortable(
              props.proposal.capitalConsequences.estimatedLongTermGainsDollars.toNumber()
            ),
          },
          "Lt Losses": {
            value:
              props.proposal.capitalConsequences.estimatedLongTermLossesDollars
                .toNumber()
                .toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                }),
            fullValue: toSortable(
              props.proposal.capitalConsequences.estimatedLongTermLossesDollars.toNumber()
            ),
          },
          "Lt Taxes": {
            value:
              props.proposal.capitalConsequences.estimatedLongTermTaxesDollars
                .toNumber()
                .toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                }),
            fullValue: toSortable(
              props.proposal.capitalConsequences.estimatedLongTermTaxesDollars.toNumber()
            ),
          },
          "St Gains": {
            value:
              props.proposal.capitalConsequences.estimatedShortTermGainsDollars
                .toNumber()
                .toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                }),
            fullValue: toSortable(
              props.proposal.capitalConsequences.estimatedShortTermGainsDollars.toNumber()
            ),
          },
          "St Losses": {
            value:
              props.proposal.capitalConsequences.estimatedShortTermLossesDollars
                .toNumber()
                .toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                }),
            fullValue: toSortable(
              props.proposal.capitalConsequences.estimatedShortTermLossesDollars.toNumber()
            ),
          },
          "St Taxes": {
            value:
              props.proposal.capitalConsequences.estimatedShortTermTaxesDollars
                .toNumber()
                .toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                }),
            fullValue: toSortable(
              props.proposal.capitalConsequences.estimatedShortTermTaxesDollars.toNumber()
            ),
          },
        },
      ]}
      emptyCell={<Skeleton />}
      hidePagination
      defaultRowsPerPage={3}
    />
  );
};

export default TradeConsequences;
